import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core'
import {Subject} from 'rxjs'
import {BreakpointService} from '../../utils/breakpoint.service'
import {takeUntil} from 'rxjs/operators'
import {PriceRange} from '../price-range.types'

@Component({
  selector: 'cft-client-price-range-card',
  templateUrl: './client-price-range-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block }'],
})
export class ClientPriceRangeCardComponent implements OnInit, OnDestroy {
  @Input() offering!: {label: string; icon?: {name: string; collection: string}}
  @Input() priceRange!: PriceRange
  @Input() numberOfItems?: number
  @Input() showBreakdown = false
  @Input() infoText?: string

  private readonly unsubscribe$ = new Subject<void>()

  constructor(readonly breakpointService: BreakpointService) {}

  ngOnInit(): void {
    this.breakpointService.breakpoints$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      if (!value.sm) {
        this.showBreakdown = false
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  toggleShowBreakdown(): void {
    if (!this.priceRange?.percentageBreakdown) {
      this.showBreakdown = false
      return
    }

    this.showBreakdown = !this.showBreakdown
  }
}
